import PropTypes from 'prop-types';
import { VIEW_TYPE_PREFERENCE_LIST, VIEW_TYPE_PREFERENCE_SHELF } from './actions/catalogue';

export const FopContainerBasketItems = PropTypes.arrayOf(PropTypes.shape({
  sku: PropTypes.string,
  quantity: PropTypes.number,
  parentSku: PropTypes.string,
  derivativesQuantity: PropTypes.number,
}));

export const FopContainerViewPreferenceShape = PropTypes.oneOf([VIEW_TYPE_PREFERENCE_LIST, VIEW_TYPE_PREFERENCE_SHELF]);

export const FopContainerVisibleFops = PropTypes.arrayOf(PropTypes.shape({
  sku: PropTypes.string,
  hash: PropTypes.number,
}));
